export default {"src":"/_next/static/media/files.76b9fe8c.svg","height":100,"width":100};